export default __webpack_public_path__ + "static/media/scrollLeft.d2d5fcc3.png";